import FaqSection from '@/v2/components/sections/common/faq-section'
import HelperSection from '@/v2/components/sections/common/helper-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import ServiceTipsSectionSection from '@/v2/components/sections/common/service-tips-section'
import WhyWeSection from '@/v2/components/sections/common/why-we-section'

import {
  benefitSectionContent,
  faqSectionContent,
  helperSectionContent,
  heroSectionContent,
  promotionalBannerSectionContent,
  serviceTipsSectionContent,
  whyWeSectionContent
} from '@/v2/constants/pages/public-pages/residential-storage-page'

interface ResidentialStoragePageProps {}

const ResidentialStoragePage: React.FC<ResidentialStoragePageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName=' 
          w-[324px] h-[218px] 
          md-mn:w-[380px] md-mn:h-[286px] 
          lg:!w-[448px] lg:!h-[313px] 
          xl-min:!w-[680px] xl-min:!h-[458px]'
        btnClassName='xl-min:!w-[285px] xl-min:!h-[50px] lg-mn:w-[240px] md-mn:w-[266px] w-[266px] h-[44px]'
        className='xl-min:[&>div:first-child]:!max-w-[745px] lg-mn:[&>div:first-child]:max-w-[436px]'
      />
      <WhyWeSection
        isBgDark
        {...whyWeSectionContent}
        className='md-mn:[&_button]:w-[331px] [&_button]:w-[258px]'
        sectionTitleClassName='md-mn:w-full w-[90%]'
      />
      <ServiceTipsSectionSection
        {...serviceTipsSectionContent}
        className='
      [&_article]:text-center
      [&_article>div]:self-center
      '
        sectionTitleClassName='md-mn:w-full w-[90%]'
      />
      <WhyWeSection
        isBgDark
        {...benefitSectionContent}
        className='
      [&_article]:bg-transparent
      [&_article]:border-none
      [&_article]:text-center
      [&_article>div]:self-center
      '
      />
      <HelperSection
        {...helperSectionContent}
        imgClassName='xl-min:!w-[618px] xl-min:!h-[387px] md-mn:w-[450px] md-mn:h-[252px] w-[350px] h-[196px]'
        className={`
          lg-mn:[&>div>div:last-of-type>div]:!flex-row-reverse
          [&>div>div:last-of-type>div]:flex-col
          `}
        sectionTitleClassName='md-mn:[&_p]:w-full [&_p]:w-[90%]'
      />

      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
        imgClassName='xl-min:!w-[559px] xl-min:!h-[316px] lg-mn:w-[340px] md-mn:w-[308px] w-[340px] h-[202px]'
        className={`
            md-mn:[&_button]:w-[273px]
            [&_button]:w-[276px]
          `}
      />
      <FaqSection isBgDark {...faqSectionContent} />
    </>
  )
}

export default ResidentialStoragePage
